// faq-accordion.js
export function initFaqAccordion(scope = document) {
    const SELECTOR_FAQ = '.dpage-faq';
    const SELECTOR_ITEM = '.dpage-faq-item';
    const SELECTOR_BTN = '.dpage-faq-item__button';
    const SELECTOR_PANEL = '.dpage-faq-item__panel';

    scope.querySelectorAll(SELECTOR_FAQ).forEach((root) => {
        if (root.dataset.faqBound === 'true') return;
        root.dataset.faqBound = 'true';

        const items = Array.from(root.querySelectorAll(SELECTOR_ITEM));

        items.forEach((item, index) => {
            const btn = item.querySelector(SELECTOR_BTN);
            const panel = item.querySelector(SELECTOR_PANEL);
            if (!btn || !panel) return;

            // link aria-controls
            if (!panel.id) panel.id = `dpage-faq-panel-${Math.random().toString(36).slice(2)}`;
            btn.setAttribute('aria-controls', panel.id);

            // initial state
            const openByChild = item.hasAttribute('data-open-initial');
            const openByParent = root.hasAttribute('data-open-first') && index === 0;
            const isOpen = openByChild || openByParent;

            btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            panel.setAttribute('data-open', isOpen ? 'true' : 'false');
        });

        // delegate clicks
        root.addEventListener('click', (e) => {
            const btn = e.target.closest(SELECTOR_BTN);
            if (!btn || !root.contains(btn)) return;
            const panelId = btn.getAttribute('aria-controls');
            const panel = panelId ? document.getElementById(panelId) : null;
            if (!panel) return;

            const expanded = btn.getAttribute('aria-expanded') === 'true';
            btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
            panel.setAttribute('data-open', expanded ? 'false' : 'true');
        });
    });
}
